export const SUCCESS_KEY = 'success';
export const WARNING_KEY = 'warning';
export const ERROR_KEY = 'error';

export const UserType = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  HR: 'hr',
  EMPLOYEE: 'employee',
  PROJECT_ADMIN: 'project-admin',
};
export const IN_TEXT = 'IN';
export const OUT_TEXT = 'OUT';

export const CLICK_SUMMRAY_TEXT = 'Click to view summary ...';
export const FORM_SUBMISSION_SUCCESS = 'Details are successfully submitted';
export const FAILURE_MESSAGE = 'Something went wrong, please try again';

export const SUBMIT_BUTTON_TEXT = 'Submit';
export const SAVE_BUTTON_TEXT = 'Save';
export const APPLY_BUTTON_TEXT = 'Apply';
export const CANCEL_BUTTON_TEXT = 'Cancel';
export const DELETE_BUTTON_TEXT = 'Delete';
export const EDIT_BUTTON_TEXT = 'Edit';
export const RESET_BUTTON_TEXT = 'Reset';

export const ACTIVE_STATUS = 'active';
export const COMPLETED_STATUS = 'completed';
export const IMAGE_UPLOAD_ERROR =
  'Something went wrong in image upload, please try again';
export const FILE_SIZE_MSG = 'Size: 2MB, pdf.';
export const NUMBER_ONLY_REGEX = /^[0-9\b]+$/;
export const LETTERS_ONLY_REGEX = /^[a-zA-Z \b]+$/;
export const DOB = new RegExp(
  '^(3[01]|[12][0-9]|0[1-9])/(1[0-2]|0[1-9])/[0-9]{4}$',
);
export const PAGE_SIZE_ARRAY = [10, 15, 20, 25, 50, 100];
export const emailValidation = (email) => {
  const regex = new RegExp(
    "([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|\"([]!#-[^-~ \t]|(\\[\t -~]))+\")@([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|[[\t -Z^-~]*])",
  );
  return !(!email || regex.test(email) === false);
};
export const specialCharValidation = (input) => {
  const regex = /^[a-zA-Z0-9 \b]+$/;
  return !input || !regex.test(input) === false;
};

// returns 2 means valid emloyee Code.
export const employeeCodeValidation = (value) => {
  const regex = /^[1-9]+[0-9]*$/; // regular expression to make sure it is a non zero number.
  const regex1 = /[\D]+/; // regular expression to check if there is any non digit character.

  if (regex1.test(value)) return 0;

  if (!regex.test(value)) {
    return 1;
  } else return 2;
};

export const ACTIVE_PROJECT = 'ACTIVE';
export const SELECT_MONTH = 'Select Month/Year';

export const NEXT_BUTTON_TEXT = 'Next month';
export const PREVIOUS_BUTTON_TEXT = 'Previous month';
export const DATEPICKER_MIN_DATE = '2020-01-01';
export const DATEPICKER_MAX_DATE = '2031-01-01';

export const SNACKBAR_400_MSG = 'Bad Request – Error 400';
export const SNACKBAR_401_MSG = 'HTTP 401 Error – Unauthorized';
export const SNACKBAR_403_MSG = 'You are not authorized to view this page';
export const SNACKBAR_404_MSG = 'We can’t find the page you’re looking for';
export const SNACKBAR_409_MSG = 'Request could not be processed';
export const SNACKBAR_500_MSG = 'Internal Server Error';
export const SNACKBAR_DEFAULT_MSG =
  'Sorry Something went wrong please try again!';
export const SNACKBAR_SUCCESS_MSG = 'Successfully Processed Request';
export const SNACKBAR_201_MSG = 'Successfully created';
export const SNACKBAR_204_MSG = 'Successfully deleted';

export const SNACKBAR_NODATA_MSG = 'Sorry No data for this date';
export const EXPAND_TEXT = 'Click To expand';

export const SearchProject = 'Search Project';
export const NO_PROJECTS = 'No Projects..';

export const SET_DATE_RANGE = 'SET_DATE_RANGE';
export const RESET_DATE_RANGE = 'RESET_DATE_RANGE';

export const SET_SELECTED_MONTH_RANGE = 'SET_SELECTED_MONTH_RANGE';
export const RESET_SELECTED_MONTH_RANGE = 'RESET_SELECTED_MONTH_RANGE';

export const SET_COLUMN_FILTER = 'SET_COLUMN_FILTER';
export const RESET_COLUMN_FILTERS = 'RESET_COLUMN_FILTERS';
export const TRIGGER_FILTERS = 'TRIGGER_FILTERS';

export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';

export const SKILLS = 'Skills';
export const SKILL = 'skills';
export const DESIGNATIONS = 'Designations';
export const DESIGNATION_NAME = 'designationNames';
export const SKILL_SUBMISSION_ERROR = 'Add at least 1 skill';

export const LeaveStatusType = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
};

export const LeaveStatusButton = {
  REJECTED: 'Rejected',
  REJECT: 'Reject',
  APPROVED: 'Approved',
  APPROVE: 'Approve',
  RESCHEDULE: 'Reschedule',
  CANCEL: 'Cancel',
};

export const WfhStatusButton = {
  REJECTED: 'Rejected',
  REJECT: 'Reject',
  APPROVED: 'Approved',
  APPROVE: 'Approve',
  RESCHEDULE: 'Reschedule',
  CANCEL: 'Cancel',
};

export const WfhStatusType = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
};

// Generic Loader props attributes

const getRowOfRect = (y_coordinate) => {
  return [
    {
      type: 'rect',
      x: '0',
      y: y_coordinate,
      rx: '3',
      ry: '3',
      width: '200',
      height: '30',
    },
    {
      type: 'rect',
      x: '220',
      y: y_coordinate,
      rx: '3',
      ry: '3',
      width: '200',
      height: '30',
    },
    {
      type: 'rect',
      x: '440',
      y: y_coordinate,
      rx: '3',
      ry: '3',
      width: '200',
      height: '30',
    },
    {
      type: 'rect',
      x: '660',
      y: y_coordinate,
      rx: '3',
      ry: '3',
      width: '200',
      height: '30',
    },
    {
      type: 'rect',
      x: '880',
      y: y_coordinate,
      rx: '3',
      ry: '3',
      width: '200',
      height: '30',
    },
    {
      type: 'rect',
      x: '1100',
      y: y_coordinate,
      rx: '3',
      ry: '3',
      width: '200',
      height: '30',
    },
  ];
};

export const ReportComponentAttribute = [
  {
    type: 'rect',
    x: '0',
    y: '15',
    rx: '3',
    ry: '3',
    width: '1500',
    height: '30',
  },
  {
    type: 'rect',
    x: '0',
    y: '50',
    rx: '3',
    ry: '3',
    width: '1000',
    height: '1',
  },
  ...getRowOfRect(65),
  ...getRowOfRect(110),
  ...getRowOfRect(155),
  ...getRowOfRect(200),
  ...getRowOfRect(245),
  ...getRowOfRect(290),
  ...getRowOfRect(335),
];

export const WFHAttribute = [
  {
    type: 'rect',
    x: '0',
    y: '45',
    rx: '0',
    ry: '0',
    width: '100%',
    height: '75',
  },
  {
    type: 'rect',
    x: '0',
    y: '130',
    rx: '0',
    ry: '0',
    width: '100%',
    height: '75',
  },
  {
    type: 'rect',
    x: '0',
    y: '215',
    rx: '0',
    ry: '0',
    width: '100%',
    height: '75',
  },
  {
    type: 'rect',
    x: '0',
    y: '300',
    rx: '0',
    ry: '0',
    width: '100%',
    height: '75',
  },
];

export const HeaderLoaderAttribute = [
  { type: 'rect', x: '9', y: '4', rx: '0', ry: '0', width: '400', height: 100 },
];

export const CalendarViewAttribute = [
  {
    type: 'rect',
    x: '0',
    y: '4',
    rx: '0',
    ry: '0',
    width: '760',
    height: '1400',
  },
];

export const PieChartLoaderAttribute = [
  { type: 'circle', cx: '220', cy: '150', r: '125' },
  {
    type: 'rect',
    x: '160',
    y: '300',
    rx: '0',
    ry: '0',
    width: '12',
    height: '12',
  },
  {
    type: 'rect',
    x: '180',
    y: '300',
    rx: '0',
    ry: '0',
    width: '100',
    height: '12',
  },
  {
    type: 'rect',
    x: '160',
    y: '316',
    rx: '0',
    ry: '0',
    width: '12',
    height: '12',
  },
  {
    type: 'rect',
    x: '180',
    y: '316',
    rx: '0',
    ry: '0',
    width: '100',
    height: '12',
  },
  {
    type: 'rect',
    x: '160',
    y: '332',
    rx: '0',
    ry: '0',
    width: '12',
    height: '12',
  },
  {
    type: 'rect',
    x: '180',
    y: '332',
    rx: '0',
    ry: '0',
    width: '100',
    height: '12',
  },
  {
    type: 'rect',
    x: '160',
    y: '348',
    rx: '0',
    ry: '0',
    width: '12',
    height: '12',
  },
  {
    type: 'rect',
    x: '180',
    y: '348',
    rx: '0',
    ry: '0',
    width: '100',
    height: '12',
  },
];

export const TimeLineLoaderAttribute = [
  { type: 'circle', cx: '230', cy: '20', r: '7' },
  {
    type: 'rect',
    x: '250',
    y: '15',
    rx: '0',
    ry: '0',
    width: '100',
    height: '12',
  },
  { type: 'circle', cx: '230', cy: '64', r: '7' },
  {
    type: 'rect',
    x: '110',
    y: '59',
    rx: '0',
    ry: '0',
    width: '100',
    height: '12',
  },
  { type: 'circle', cx: '230', cy: '108', r: '7' },
  {
    type: 'rect',
    x: '250',
    y: '103',
    rx: '0',
    ry: '0',
    width: '100',
    height: '12',
  },
  { type: 'circle', cx: '230', cy: '152', r: '7' },
  {
    type: 'rect',
    x: '110',
    y: '147',
    rx: '0',
    ry: '0',
    width: '100',
    height: '12',
  },
];

export const TimesheetsComponentLoaderAttribute = [
  {
    type: 'rect',
    x: '0',
    y: '15',
    rx: '0',
    ry: '0',
    width: '100%',
    height: '475',
  },
];

export const WorkReportsComponentLoaderAttribute = [
  {
    type: 'rect',
    x: '0',
    y: '15',
    rx: '0',
    ry: '0',
    width: '100%',
    height: '475',
  },
];

export const AdminPeopleLoaderAttribute = [
  {
    type: 'rect',
    x: '25%',
    y: '26',
    rx: '0',
    ry: '0',
    width: '50%',
    height: '35',
  },
  {
    type: 'rect',
    x: '0',
    y: '90',
    rx: '0',
    ry: '0',
    width: '100%',
    height: '375',
  },
];

export const ManageLoaderAttribute = [
  {
    type: 'rect',
    x: '0',
    y: '15',
    rx: '3',
    ry: '3',
    width: '150',
    height: '30',
  },
  {
    type: 'rect',
    x: '170',
    y: '15',
    rx: '3',
    ry: '3',
    width: '150',
    height: '30',
  },
  {
    type: 'rect',
    x: '0',
    y: '50',
    rx: '3',
    ry: '3',
    width: '1000',
    height: '1',
  },
  {
    type: 'rect',
    x: '500',
    y: '160',
    rx: '3',
    ry: '3',
    width: '500',
    height: '40',
  },
  {
    type: 'rect',
    x: '20',
    y: '70',
    rx: '3',
    ry: '3',
    width: '1000',
    height: '80',
  },
  {
    type: 'rect',
    x: '20',
    y: '220',
    rx: '3',
    ry: '3',
    width: '1000',
    height: '250',
  },
];

export const LeavesLoaderAttribute = [
  {
    type: 'rect',
    x: '0',
    y: '45',
    rx: '0',
    ry: '0',
    width: '30%',
    height: '115',
  },
  {
    type: 'rect',
    x: '35%',
    y: '45',
    rx: '0',
    ry: '0',
    width: '30%',
    height: '115',
  },
  {
    type: 'rect',
    x: '70%',
    y: '45',
    rx: '0',
    ry: '0',
    width: '30%',
    height: '115',
  },
  {
    type: 'rect',
    x: '0',
    y: '200',
    rx: '0',
    ry: '0',
    width: '100%',
    height: '355',
  },
];

export const TableComponentLoaderAttribute = [
  {
    type: 'rect',
    x: '20',
    y: '0',
    rx: '3',
    ry: '3',
    width: '1000',
    height: '90',
  },
  {
    type: 'rect',
    x: '20',
    y: '100',
    rx: '3',
    ry: '3',
    width: '1000',
    height: '90',
  },
  {
    type: 'rect',
    x: '20',
    y: '200',
    rx: '3',
    ry: '3',
    width: '1000',
    height: '90',
  },
  {
    type: 'rect',
    x: '20',
    y: '300',
    rx: '3',
    ry: '3',
    width: '1000',
    height: '90',
  },
];

export const ProfileComponentLoaderAttribute = [
  {
    type: 'rect',
    x: '17%',
    y: '5%',
    rx: '1%',
    ry: '1%',
    width: '33%',
    height: '10%',
  },
  {
    type: 'rect',
    x: '0.5%',
    y: '17.5%',
    rx: '1%',
    ry: '1%',
    width: '66%',
    height: '80%',
  },
  {
    type: 'rect',
    x: '68%',
    y: '2%',
    rx: '1%',
    ry: '1%',
    width: '44%',
    height: '50%',
  },
];

export const LeavesTypesLoaderAttribute = [
  {
    type: 'rect',
    x: '30',
    y: '120',
    rx: '8',
    ry: '8',
    width: '200',
    height: '140',
  },
  {
    type: 'rect',
    x: '250',
    y: '120',
    rx: '8',
    ry: '8',
    width: '200',
    height: '140',
  },
  {
    type: 'rect',
    x: '470',
    y: '120',
    rx: '8',
    ry: '8',
    width: '200',
    height: '140',
  },
  {
    type: 'rect',
    x: '690',
    y: '120',
    rx: '8',
    ry: '8',
    width: '200',
    height: '140',
  },
  {
    type: 'rect',
    x: '30',
    y: '290',
    rx: '8',
    ry: '8',
    width: '200',
    height: '140',
  },
  {
    type: 'rect',
    x: '250',
    y: '290',
    rx: '8',
    ry: '8',
    width: '200',
    height: '140',
  },
  {
    type: 'rect',
    x: '470',
    y: '290',
    rx: '8',
    ry: '8',
    width: '200',
    height: '140',
  },
  {
    type: 'rect',
    x: '690',
    y: '290',
    rx: '8',
    ry: '8',
    width: '200',
    height: '140',
  },
];

export const HolidaysComponentLoaderAttribute = [
  {
    type: 'rect',
    x: '0',
    y: '0',
    rx: '3',
    ry: '3',
    width: '90%',
    height: '25%',
  },
  {
    type: 'rect',
    x: '0',
    y: '30%',
    rx: '3',
    ry: '3',
    width: '90%',
    height: '25%',
  },
  {
    type: 'rect',
    x: '0',
    y: '60%',
    rx: '3',
    ry: '3',
    width: '90%',
    height: '25%',
  },
];

export const CommonComponentLoaderAttribute = [
  {
    type: 'rect',
    x: '30',
    y: '20',
    rx: '8',
    ry: '8',
    width: '450',
    height: '60',
  },
  {
    type: 'rect',
    x: '540',
    y: '30',
    rx: '8',
    ry: '8',
    width: '150',
    height: '40',
  },
  {
    type: 'rect',
    x: '30',
    y: '120',
    rx: '20',
    ry: '20',
    width: '200',
    height: '50',
  },
  {
    type: 'rect',
    x: '240',
    y: '120',
    rx: '20',
    ry: '20',
    width: '200',
    height: '50',
  },
  {
    type: 'rect',
    x: '450',
    y: '120',
    rx: '20',
    ry: '20',
    width: '200',
    height: '50',
  },
  {
    type: 'rect',
    x: '660',
    y: '120',
    rx: '20',
    ry: '20',
    width: '200',
    height: '50',
  },
  {
    type: 'rect',
    x: '30',
    y: '190',
    rx: '20',
    ry: '20',
    width: '200',
    height: '50',
  },
  {
    type: 'rect',
    x: '240',
    y: '190',
    rx: '20',
    ry: '20',
    width: '200',
    height: '50',
  },
  {
    type: 'rect',
    x: '450',
    y: '190',
    rx: '20',
    ry: '20',
    width: '200',
    height: '50',
  },
  {
    type: 'rect',
    x: '660',
    y: '190',
    rx: '20',
    ry: '20',
    width: '200',
    height: '50',
  },
];

export const colorOptionsLeaveType = [
  {
    label: 'Blue',
    color: '#039BE5',
  },
  {
    label: 'Yellow',
    color: '#F6BF26',
  },
  {
    label: 'Red',
    color: '#D50000',
  },
  {
    label: 'Green',
    color: '#33B679',
  },
  {
    label: 'Orange',
    color: '#F4511E',
  },
  {
    label: 'Pink',
    color: '#E67C73',
  },
  {
    label: 'Purple',
    color: '#8E24AA',
  },
  {
    label: 'Violet',
    color: '#7986CB',
  },
];
//this is wfh color highlight to show up in calendar
export const wfhCalenderHighlightColor = '#D8BFD8';
export const holidayCalenderHighlightColor = '#d4a373';

export const SET_FILTERDATA = 'SET_FILTERDATA';
export const RESET_FILTERDATA = 'RESET_FILTERDATA';

export const SET_FILTER_CONFIG = 'SET_FILTER_CONFIG';
export const RESET_FILTER_CONFIG = 'RESET_FILTER_CONFIG';

export const DATAGRID_FILTER_CONFIG = {
  '& .MuiDataGrid-columnHeader': {
    position: 'relative',
  },
  '& .MuiDataGrid-menuIcon, & .MuiDataGrid-menuIconButton': {
    visibility: 'visible !important',
    opacity: '1 !important',
    position: 'absolute',
    right: '0.5rem',
    top: '50%',
    transform: 'translateY(-50%)',
  },
  '& .MuiDataGrid-sortIcon': {
    visibility: 'visible !important',
    opacity: '1 !important',
    position: 'absolute',
    left: '0',
    top: '50%',
    transform: 'translateY(-50%)',
  },

  '& .MuiDataGrid-columnHeaderTitleContainer': {
    paddingRight: '50px',
  },

  '& .MuiDataGrid-columnHeader:hover .MuiDataGrid-menuIconButton, & .MuiDataGrid-columnHeader:hover .MuiDataGrid-sortIcon':
    {
      visibility: 'visible !important',
      opacity: '1 !important',
      position: 'absolute',
    },
};
